import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const fullHeightCardCSS = css`
    width: 100%;
    height: 100%;
`;

export const containerCSS = css`
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
`;

export const rowClassname = css`
    cursor: pointer;
`;

export const backButton = css`
    margin-top: ${Spacing.MD}px;
    padding-left: 0 !important; /* needed to override SDS button styles */
`;
